export const PAGE_TEMPLATES_API = '/api/dashboard/customer/page-templates'
